import { useNavigate } from 'react-router-dom';

/**
 * Hook that returns a goBack function which navigates back in history
 * if there is history available, otherwise navigates to the fallback path.
 * This handles the case where a user lands directly on a page via a shared link.
 */
function useGoBack(fallback = '/') {
  const navigate = useNavigate();

  return () => {
    // React Router v6 stores a navigation index in history.state
    // When idx > 0, the user has navigated within the app and can go back
    if (window.history?.state?.idx > 0) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };
}

export default useGoBack;
